var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{attrs:{"show-promotes":false}},[_c('thanks',{attrs:{"email":_vm.email,"title":_vm.title}},[_c('view-account')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }